import React, { useEffect, useState } from "react";
import {
 
  Label,
  Slider,
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  TableCellLayout,
  Button,
  Field,
  Input,
  Dropdown,
  Option,
  RadioGroup,
  Radio,
} from "@fluentui/react-components";
import { DeleteRegular, EditRegular, Dismiss20Regular ,AddCircle24Regular} from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";
import SearchAgent from "../GenericComponent/SearchAgent";
import { ConfirmAlert } from "../GenericComponent/ConfirmAlert";
import InfoButton from "../GenericComponent/InfoButton";
import AuthorizedActivity from "./authorizedActivity";
import "../CSS/QueueAgentList.css";

export default function QueueAgentList(props) {

  const { t } = useTranslation();
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [agentsRows, setAgentsRows] = useState([]);
  const [newReasonCode, setNewReasonCode] = useState("");
  const [editingReasonCode, setEditingReasonCode] = useState(null);
  const [editValue, setEditValue] = useState("");
  const columns = [
    { columnKey: "AGENT_NAME", label: t("AGENT_NAME") },
    { columnKey: "EMAIL", label: t("EMAIL") },
    { columnKey: "SKILL", label: t("SKILL") },
    { columnKey: "ACTION", label: t("ACTION") },
  ];

  useEffect(() => {
    if (props.queue.agentDetails) {
      const rows = Object.entries(props.queue.agentDetails).map(
        ([id, details]) => ({
          id,
          ...details,
        })
      );
      setAgentsRows(rows);
    }
  }, [props.queue.agentDetails]);

  const removeAgent = (agent) => {
    const newDetails = { ...props.queue.agentDetails };
    delete newDetails[agent.id];

    props.setQueue({
      ...props.queue,
      agentsIds: props.queue.agentsIds.filter((id) => id !== agent.id),
      agentDetails: newDetails,
    });

    setSelectedAgent(null);
  };

  const addReasonCode = () => {
    if (!newReasonCode.trim()) return;
    
    const currentReasonCodes = props.queue.reasonCodes || [];
    if (currentReasonCodes.includes(newReasonCode.trim())) {
      // TODO: Show error message - reason code already exists
      return;
    }
    
    props.setQueue({
      ...props.queue,
      reasonCodes: [...currentReasonCodes, newReasonCode.trim()],
    });
    setNewReasonCode("");
  };

  const deleteReasonCode = (code) => {
    const updatedReasonCodes = (props.queue.reasonCodes || []).filter(rc => rc !== code);
    const updates = {
      ...props.queue,
      reasonCodes: updatedReasonCodes,
    };
    
    // If deleted code was the default, clear the default
    if (props.queue.defaultReasonCode === code) {
      updates.defaultReasonCode = "";
    }
    
    props.setQueue(updates);
  };

  const updateReasonCode = (oldCode, newCode) => {
    if (!newCode.trim()) return;
    
    const updatedReasonCodes = (props.queue.reasonCodes || []).map(rc => 
      rc === oldCode ? newCode.trim() : rc
    );
    
    const updates = {
      ...props.queue,
      reasonCodes: updatedReasonCodes,
    };
    
    // Update default if it was the edited one
    if (props.queue.defaultReasonCode === oldCode) {
      updates.defaultReasonCode = newCode.trim();
    }
    
    props.setQueue(updates);
    setEditingReasonCode(null);
    setEditValue("");
  };

  const setDefaultReasonCode = (code) => {
    props.setQueue({
      ...props.queue,
      defaultReasonCode: code,
    });
  };

  return (
    <div className="add-queue-root" >
      <div style={{marginLeft:'20%'}}>
      {/* Agent Hunt Strategy Section */}
      <Label weight="semibold">
        {t("AGENT_HUNT_STRATEGYS")}
        <InfoButton infoKey="AGENT_HUNT_STRATEGYS" category="QUEUES" />
      </Label>
      <RadioGroup
        className="queue-form-radio-group"
        layout="horizontal"
        value={props.queue?.huntMethod}
        disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
        onChange={(_, data) => {
          props.setQueue({
            ...props.queue,
            huntMethod: data.value,
          });
        }}
      >
        <Radio value="attendant" label={t("ATTENDANT")} />
        <Radio value="serial" label={t("SERIAL")} />
        <Radio value="roundRobin" label={t("ROUND_ROBIN")} />
        <Radio value="longestIdle" label={t("LONGEST_IDLE")} />
      </RadioGroup>

      <Field label={
        <>
          {t("AUTHORIZED_ACTIVITY_VALUES")}
          <InfoButton infoKey="AUTHORIZED_ACTIVITY_VALUES" category="QUEUES" />
        </>
      }
        className="queue-form-field authorized-activity-field"
      >
        <AuthorizedActivity queue={props.queue} setQueue={props.setQueue} permissions={props.permissions} isUpdate={props.isUpdate} />
      </Field>

      {/* Reason Codes Section */}
      <div className="agent-activities-section">
        <Label weight="semibold" className="agent-activities-title">
          {t("AGENT_ACTIVITIES")}
        </Label>
        
        {/* Add Reason Code Input */}
        <div className="activity-input-container">
          <Input
      
            placeholder={t("ENTER_ACTIVITY")}
            value={newReasonCode}
            onChange={(e, data) => setNewReasonCode(data.value)}
            disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
            className=" dropdown-inline"
          />
          <Button
            appearance="primary"
            icon={<AddCircle24Regular />}
            className="btn-reason-code"
            onClick={addReasonCode}
            disabled={!newReasonCode.trim() || (props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate)}
          />
        </div>

        {/* Reason Codes List */}
        {props.queue.reasonCodes && props.queue.reasonCodes.length > 0 && (
          <>
            <div className="activities-list">
              {props.queue.reasonCodes.map((code, index) => (
                <div key={index} className="activity-item">
                  {editingReasonCode === code ? (
                    <>
                      <Input
                        value={editValue}
                        onChange={(e, data) => setEditValue(data.value)}
                        className=" dropdown-inline-default"
                      />
                      <Button
                         appearance="subtle"
                        icon={<EditRegular />}
                        onClick={() => updateReasonCode(code, editValue)}
                        disabled={!editValue.trim()}
                      />
                      
                      <Button
                      icon={<Dismiss20Regular />}
                     appearance="subtle"
                        onClick={() => {
                          setEditingReasonCode(null);
                          setEditValue("");
                        }}
                     />
                    </>
                  ) : (
                    <>
                      <span className="activity-item-text">{t(code)}</span>
                      <Button
                        appearance="subtle"
                        icon={<EditRegular />}
                        size="small"
                        onClick={() => {
                          setEditingReasonCode(code);
                          setEditValue(code);
                        }}
                        disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                      />
                      <Button
                        appearance="subtle"
                        icon={<DeleteRegular />}
                        size="small"
                        onClick={() => deleteReasonCode(code)}
                        disabled={props.isUpdate ? !props.permissions?.canDelete : !props.permissions?.canCreate}
                      />
                    </>
                  )}
                </div>
              ))}
            </div>
          </>
        )}

        {/* Default Reason Code Dropdown */}
        {props.queue.reasonCodes && props.queue.reasonCodes.length > 0 && (
          <Field label={t("DEFAULT_ACTIVITY")} weight="semibold"  className="default-activity-field" >
            <Dropdown
               className=" dropdown-inline"
              placeholder={t("SELECT_DEFAULT_ACTIVITY")}
              value={props.queue.defaultReasonCode ? t(props.queue.defaultReasonCode) : ""}
              selectedOptions={props.queue.defaultReasonCode ? [props.queue.defaultReasonCode] : []}
              onOptionSelect={(e, data) => setDefaultReasonCode(data.optionValue)}
              disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
            >
              {props.queue.reasonCodes.map((code) => (
                <Option key={code} value={code}>
                  {t(code)}
                </Option>
              ))}
            </Dropdown>
          </Field>
        )}
      </div>

      <Field
     label={t("AGENTS_LIST")}
        className="field-style"
       
      >
        <SearchAgent
          agents={props.agents}
          disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
  selectedIds={props.queue.agentsIds ?? []}
          onSelect={(agent) => {
            console.log('Selected agent:', agent);
            props.setQueue({
              ...props.queue,
              agentsIds: [...(props.queue.agentsIds ?? []), agent.id],

              agentDetails: {
                ...(props.queue.agentDetails ?? {}),
                [agent.id]: {
                  displayName: agent.displayName,
                  email: agent.email,
                  state: agent.state &&  agent.state !== "" ?agent.state:"READY" ,
                  skill: 100,
                  lastUpdated:
                    agent.lastUpdated ?? Math.floor(Date.now() / 1000),
                },
              },
            });
          }}
        />
      </Field>
      <div className="table-wrapper table-container   ">
        <Table role="grid" aria-label="Media table" className="table-style">
          {/* HEADER */}
          <TableHeader>
            <TableRow className="header-style">
              {columns.map((column) => (
                <TableHeaderCell
                  key={column.columnKey}
                  className={`cell-bold ${
                    column.columnKey === "ACTION" ? "cell-right" : ""
                  }`}
                >
                  {column.label}
                </TableHeaderCell>
              ))}
            </TableRow>
          </TableHeader>

          {/* BODY scrollable */}
          <TableBody>
            {agentsRows.map((agent, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TableCellLayout>{agent.displayName}</TableCellLayout>
                </TableCell>

                <TableCell>
                  <TableCellLayout>{agent.email}</TableCellLayout>
                </TableCell>

                <TableCell>
                  <TableCellLayout>
                    {" "}
                    <div className="slider-style" >
                      <Slider
                        aria-valuetext={`Value is ${agent.skill}`}
                        value={agent.skill}
                        min={0}
                        max={100}
                        disabled={props.isUpdate ? !props.permissions?.canUpdate : !props.permissions?.canCreate}
                        onChange={(_, data) => {
                          props.setQueue({
                            ...props.queue,
                            agentDetails: {
                              ...(props.queue.agentDetails ?? {}),
                              [agent.id]: {
                                displayName: agent.displayName,
                                email: agent.email,
                                state: agent.state,
                                skill: data.value,
                                lastUpdated:
                                  agent.lastUpdated ??
                                  Math.floor(Date.now() / 1000),
                              },
                            },
                          });
                        }}
                      />
                      <Label>{agent.skill + "%"}</Label>
                    </div>
                  </TableCellLayout>
                </TableCell>

                <TableCell className="cell-right">
                  <Button
                    appearance="subtle"
                    icon={<DeleteRegular />}
                    aria-label="Delete"
                    disabled={!props.permissions?.canDelete}
                    onClick={() => setSelectedAgent(agent)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {selectedAgent && (
        <ConfirmAlert
          open={!!selectedAgent}
          name={selectedAgent.displayName}
          onConfirm={() => removeAgent(selectedAgent)}
          onCancel={() => setSelectedAgent(null)}
        />
      )}
      </div>
    </div>
  );
}
